export const CAMPAIGNS_TABLE_COLUMNS = [
  // Nombre de la campaña
  { field: 'nombre', align: 'left', width: 200 },
  // Código de la campaña
  { field: 'codigo', align: 'left', width: 150 },
  // Comunidad Autónoma
  { field: 'ccaa', align: 'left', width: 150 },
  // Mercados
  { field: 'mercados', align: 'left', width: 150, multiple: true },
  // Productos
  { field: 'productos', align: 'left', width: 300, multiple: true },
  { field: 'fechainicio', align: 'left', type: 'date', width: 150, exportType: 'date_iso' },
  { field: 'fechafin', align: 'left', type: 'date', width: 150, exportType: 'date_iso' },
  // Subvención
  { field: 'descuento', align: 'right', width: 140 },
  // Ingreso a cuenta
  { field: 'ingreso', align: 'right', width: 100 },
  {
    field: 'fecha_publicacion',
    align: 'left',
    type: 'date',
    width: 150,
    exportType: 'date_iso',
  },
  {
    field: 'fecha_prorrogada',
    align: 'left',
    type: 'date',
    width: 150,
    exportType: 'date_iso',
  },
  { field: 'financiacion', align: 'left', width: 150 },
  // Prioridad de la campaña
  // { field: 'prioridad', align: 'left', width: 150 },
  // Activa
  { field: 'activa', disableClick: true, align: 'center', width: 100, exportType: 'boolean' },
  { field: 'actions', disableClick: true, align: 'center', width: 100, export: false },
]

export const DEFAULT_QUERY = { _pagina: '1', _num_x_pagina: '10' }
